import React, { useState } from 'react';
import { UseFormReturn } from 'react-hook-form';

import {
  Company,
  isServiceTitanApiCompany,
  isServiceTitanPortalV2Company,
  isStCapacityCompany
} from '_lib/api/apiTypes.shim';
import { AuthUser } from '_lib/featureComponents/auth/auth.types';

import {
  CompanyConfigZipZonesForm,
  CompanyConfigZipZonesFormValues,
  companyConfigZipZonesFormValues
} from '../../CompanyFormItems/CompanyConfigZipZonesForm/CompanyConfigZipZonesForm';
import { FormWrapper } from '../../CompanyFormItems/FormWrapper/FormWrapper';

import { TabChangeObj } from '../CompanyUpdate';

import { useCompanyUpdateForm } from './hooks/useCompanyUpdateForm';
import { useZipCodeData } from './ZipCodes/hooks/useZipCodeData';
import { ZipCodes } from './ZipCodes/ZipCodes';

export type CompanyConfigZipZonesProps = {
  company: Company;
  authUser: AuthUser;
  tabChangeObj: TabChangeObj;
  isTabSelected: boolean;
};

export const CompanyConfigZipZones = (props: CompanyConfigZipZonesProps) => {
  const { company, authUser, tabChangeObj, isTabSelected } = props;
  const { companyUpdateFormContext, validationErrors, allErrors, handleSave, isPending } = useCompanyUpdateForm({
    company,
    authUser,
    formValuePaths: companyConfigZipZonesFormValues,
    tabChangeObj,
    snackMessage: 'Company saved'
  });

  const canUseZipCodeManagement =
    isServiceTitanApiCompany(company) || isStCapacityCompany(company) || isServiceTitanPortalV2Company(company);

  const useZipCodeManagement = !companyUpdateFormContext.watch('isZoned') && canUseZipCodeManagement;

  const [tabHasBeenSelected, setTabHasBeenSelected] = useState(false);
  if (isTabSelected && !tabHasBeenSelected) {
    setTabHasBeenSelected(true);
  }

  const zipCodeData = useZipCodeData(company.id, { enabled: useZipCodeManagement && tabHasBeenSelected });

  if (useZipCodeManagement) {
    return (
      <ZipCodes
        company={company}
        onDisableZipCodes={() => companyUpdateFormContext.setValue('isZoned', true)}
        zipCodeData={zipCodeData}
      />
    );
  }

  return (
    <FormWrapper
      isFetchingOrPending={isPending}
      formValues={companyUpdateFormContext.getValues()}
      onSave={handleSave}
      validationErrors={validationErrors}
      allErrors={allErrors}
      disabled={!company?.isActive}>
      <CompanyConfigZipZonesForm
        companyConfigZipZonesFormContext={
          companyUpdateFormContext as unknown as UseFormReturn<CompanyConfigZipZonesFormValues>
        }
        company={company}
        onSetIsZoned={(isZoned) => {
          if (company.isActive && !isZoned && canUseZipCodeManagement) {
            handleSave();
          }
        }}
      />
    </FormWrapper>
  );
};
